import React, { ReactElement, MouseEventHandler } from 'react';

interface Props {
    readonly onClick: MouseEventHandler;
    readonly children: ReactElement | Array<ReactElement>
}

function ButtonSansStyle({
    onClick,
    children,
}: Props) {
    return (
        <button type="button" onClick={onClick} className="appearance-none border-none bg-transparent p-0 m-0">
            {children}
        </button>
    );
}

export default ButtonSansStyle;
